import { useCallback, useState } from "react";
import { LayoutChangeEvent } from "react-native";

export const useComponentWidth = (
  { initialWidth }: { initialWidth?: number | null } = {},
) => {
  const [width, setWidth] = useState<number | null>(initialWidth ?? null);
  const layoutSetWidth = useCallback(({ nativeEvent }: LayoutChangeEvent) => {
    setWidth(nativeEvent.layout.width);
  }, []);
  return { width, layoutSetWidth };
};
